/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BigQueryNativePitrBackupResourceType } from '../models/BigQueryNativePitrBackupResourceType';

export class BigQueryNativePitrBackupPolicyPlan {
  /**
  * Number of days to retain data using BigQuery time travel. BigQuery time travel supports up to 7 days. Must be exactly 7. 
  */
  'retentionDays': number;
  'resourceType': BigQueryNativePitrBackupResourceType;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "retentionDays",
      "baseName": "retentionDays",
      "type": "number",
      "format": ""
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "BigQueryNativePitrBackupResourceType",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BigQueryNativePitrBackupPolicyPlan.attributeTypeMap;
  }

  public constructor() {
  }
}

